<template>
  <div>
    <!--  版本信息确认  -->
    <release-review-version-confirm @getVersionData="getVersionData"/>
    <el-divider></el-divider>
    <div>
      <releaseReviewItem preset="颈动脉" mode="B模式" @getReviewData="getCarotidB"/>
      <releaseReviewItem preset="颈动脉" mode="C模式" @getReviewData="getCarotidC"/>
      <releaseReviewItem preset="颈动脉" mode="D模式" @getReviewData="getCarotidD"/>
      <releaseReviewItem preset="椎动脉" mode="B模式" @getReviewData="getVAB"/>
      <releaseReviewItem preset="椎动脉" mode="C模式" @getReviewData="getVAC"/>
      <releaseReviewItem preset="椎动脉" mode="D模式" @getReviewData="getVAD"/>
      <releaseReviewItem preset="甲状腺" mode="B模式长轴" @getReviewData="getThyroidBL"/>
      <releaseReviewItem preset="甲状腺" mode="C模式长轴" @getReviewData="getThyroidCL"/>
      <releaseReviewItem preset="甲状腺" mode="B模式短轴" @getReviewData="getThyroidBS"/>
      <releaseReviewItem preset="甲状腺" mode="C模式短轴" @getReviewData="getThyroidCS"/>
      <releaseReviewItem preset="外周血管" mode="B模式" @getReviewData="getPVB"/>
      <releaseReviewItem preset="外周血管" mode="C模式" @getReviewData="getPVC"/>
      <releaseReviewItem preset="外周血管" mode="D模式" @getReviewData="getPVD"/>
      <releaseReviewItem preset="其他" mode="" @getReviewData="getOther"/>
    </div>
  </div>
</template>

<script>
import ReleaseReviewItem from "./ReleaseReviewItem";
import ReleaseReviewVersionConfirm from "./ReleaseReviewVersionConfirm";

export default {
  name: "ReleaseReviewForLinear",
  components: {
    ReleaseReviewItem,
    ReleaseReviewVersionConfirm
  },
  data() {
    return {
      linear: {
        carotid_b_opinion: '',
        carotid_b_images: [],
        carotid_c_opinion: '',
        carotid_c_images: [],
        carotid_d_opinion: '',
        carotid_d_images: [],
        va_b_opinion: '',
        va_b_images: [],
        va_c_opinion: '',
        va_c_images: [],
        va_d_opinion: '',
        va_d_images: [],
        thyroid_b_long_opinion: '',
        thyroid_b_long_images: [],
        thyroid_c_long_opinion: '',
        thyroid_c_long_images: [],
        thyroid_b_short_opinion: '',
        thyroid_b_short_images: [],
        thyroid_c_short_opinion: '',
        thyroid_c_short_images: [],
        pv_b_opinion: '',
        pv_b_images: [],
        pv_c_opinion: '',
        pv_c_images: [],
        pv_d_opinion: '',
        pv_d_images: [],
        version_confirm: '',
        other_opinion: '',
        other_images: []
      }
    }
  },
  watch: {
    linear: {
      handler: function (val){
        this.sendLinearData(val);
      },
      deep: true
    }
  },
  methods: {
    // 发送最新线阵数据给父路由
    sendLinearData(data) {
      this.$emit('getLinearData', this.linear);
    },
    // 得到颈动脉B模式的调用
    getCarotidB(data) {
      this.linear.carotid_b_opinion = data.opinion;
      this.linear.carotid_b_images = data.fileList;
    },
    // 得到颈动脉C模式的反馈调用
    getCarotidC(data) {
      this.linear.carotid_c_opinion = data.opinion;
      this.linear.carotid_c_images = data.fileList;
    },
    // 得到颈动脉D模式的反馈调用
    getCarotidD(data) {
      this.linear.carotid_d_opinion = data.opinion;
      this.linear.carotid_d_images = data.fileList;
    },
    // 得到椎动脉B模式的反馈调用
    getVAB(data) {
      this.linear.va_b_opinion = data.opinion;
      this.linear.va_b_images = data.fileList;
    },
    // 得到椎动脉C模式的反馈调用
    getVAC(data) {
      this.linear.va_c_opinion = data.opinion;
      this.linear.va_c_images = data.fileList;
    },
    // 得到椎动脉D模式的反馈调用
    getVAD(data) {
      this.linear.va_d_opinion = data.opinion;
      this.linear.va_d_images = data.fileList;
    },
    // 得到甲状腺B模式长轴的反馈调用
    getThyroidBL(data) {
      this.linear.thyroid_b_long_opinion = data.opinion;
      this.linear.thyroid_b_long_images = data.fileList;
    },
    // 得到甲状腺C模式长轴的反馈调用
    getThyroidCL(data) {
      this.linear.thyroid_c_long_opinion = data.opinion;
      this.linear.thyroid_c_long_images = data.fileList;
    },
    // 得到甲状腺B模式短轴的反馈调用
    getThyroidBS(data) {
      this.linear.thyroid_b_short_opinion = data.opinion;
      this.linear.thyroid_b_short_images = data.fileList;
    },
    // 得到甲状腺C模式短轴的反馈调用
    getThyroidCS(data) {
      this.linear.thyroid_c_short_opinion = data.opinion;
      this.linear.thyroid_c_short_images = data.fileList;
    },
    // 得到外周血管B模式的反馈调用
    getPVB(data) {
      this.linear.pv_b_opinion = data.opinion;
      this.linear.pv_b_images = data.fileList;
    },
    // 得到外周血管C模式的反馈调用
    getPVC(data) {
      this.linear.pv_c_opinion = data.opinion;
      this.linear.pv_c_images = data.fileList;
    },
    // 得到外周血管D模式的反馈调用
    getPVD(data) {
      this.linear.pv_d_opinion = data.opinion;
      this.linear.pv_d_images = data.fileList;
    },
    // 得到其他的反馈调用
    getOther(data) {
      this.linear.other_opinion = data.opinion;
      this.linear.other_images = data.fileList;
    },
    // 得到用户的信息
    getInfoData(data) {
      this.formInline.name = data.name;
      this.formInline.phone = data.phone;
      this.formInline.probeSn = data.probeSn;
      this.formInline.probeType = data.probeType;
    },
    // 得到测试版本信息
    getVersionData(data) {
      this.linear.version_confirm = data;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/release_review/ReleaseReviewForLinear.vue